import { hbs } from 'ember-cli-htmlbars';
export default hbs("<hr\n  class={{class-names\n    \"bvHr\"\n    (if (includes @size (array \"full\" \"half\" \"quarter\")) (concat \"bvHr--\" @size))\n  }}\n  ...attributes\n/>")